import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from "@angular/router";
import { HttpParams } from '@angular/common/http';
import { LOCALE_ID, Inject } from '@angular/core';
import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import { NgModule } from '@angular/core';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


    constructor(@Inject(LOCALE_ID) protected localeId: string, private route: ActivatedRoute, private http: HttpClient, private router: Router, ) {this.checkParams()}
    profileName = '';
    mondiaStatus = '';
    mondiacustID = '';
    usernameLogin = '';
    passLogin = '';
    mondiaOperator = '';
    siteData: any = [];
    operatorID = '';
    redirectURL = '';
    MTNsiteID: number = 8;
    siteID = environment.siteID;
    doi = environment['doi'];
    tempPass = '';
    msisdn = '';
    MTNFail: boolean = environment['isMTN'];
    loaded: boolean = false;
    username = '';
    isTrue: boolean = false;
    orderObj: any = [];
    hideUsername: boolean = false;
    preferredCountries = [
        { "country": "South Africa", "code": 'za', "dialcode": "+27" },
        { "country": "Nigeria", "code": 'ng', "dialcode": "+97" },
        { "country": "Tunisia", "code": 'tu', "dialcode": "+22" },
        { "country": "Egypt", "code": 'eg', "dialcode": "+20" }
    ];

    public checkParams() {
        this.route.queryParamMap.subscribe(params => {
            this.orderObj = { ...params.keys, ...params };
            this.mondiacustID = this.orderObj.params.customerId;
            this.msisdn = this.orderObj.params.msisdn;
            console.log(this.orderObj);
            this.mondiaStatus = this.orderObj.params.status;
            this.mondiaOperator = this.orderObj.params.operator;
            if (this.mondiaStatus == 'SUCCESS' && this.mondiacustID) {
                this.hideUsername = true;
                this.logincustomerID();
            }
            else if (this.mondiaStatus == 'SUCCESS' && this.msisdn != 'undefined' && this.msisdn.length > 0 ) {
                this.hideUsername = true;
                console.log('cust to cust MTN')
                this.loginCustomertoCustomer();
            }
           
            else if (this.mondiaStatus == 'ERROR' && this.msisdn == 'undefined') {
                this.hideUsername = false;
                this.MTNFail = false;
                
                console.log('MTN FAIL error');
            }
            else if (this.mondiaStatus == 'ERROR') {
                console.log('Mondia error');
            }
            else if (this.MTNsiteID == this.siteID && !this.msisdn) {
                this.redirectMTN();
                console.log('MTN Redirect')
            }
            else {
                console.log('Mondia Redirect')
                
            }
        })
    }
    redirectMTN() { 
       console.log('redirect to MTN')
        if (window.location.pathname.indexOf('\/en\/') > -1) {
            window.location.href = 'http://18.223.7.91?operatorId=MTNNigeria&redirectUrl='+environment['link']+'en%2Flogin'
            console.log('EN/LOGIN');
        }
        else if (window.location.pathname.indexOf('\/fr\/') > -1) {
            window.location.href = 'http://18.223.7.91?operatorId=MTNNigeria&redirectUrl&redirectUrl='+environment['link']+'fr%2Flogin'
            console.log('FR/LOGIN');
        }
        else if (window.location.pathname.indexOf('\/ar\/') > -1) {
            window.location.href = 'http://18.223.7.91?operatorId=MTNNigeria&redirectUrl&redirectUrl='+environment['link']+'ar%2Flogin'
            console.log('AR/LOGIN');
        }
        else { 
           console.log('local testing...')
            
        }
    }
    // redirectToMondia() {
    //     this.operatorID = localStorage.getItem('operatorID');
    //     if (!this.operatorID) {
    //         this.operatorID = '0';
    //     }
    //     if (window.location.pathname.indexOf('\/en\/') > -1) {
    //         window.location.href = 'http://login.mondiamediamena.com/billinggw-lcm/billing?method=getcustomer&merchantId=243&redirect='+environment['link']+'en%2Flogin&operatorId=' + this.operatorID
    //         console.log('EN/LOGIN');
    //     }
    //     else if (window.location.pathname.indexOf('\/fr\/') > -1) {
    //         window.location.href = 'http://login.mondiamediamena.com/billinggw-lcm/billing?method=getcustomer&merchantId=243&redirect='+environment['link']+'fr%2Flogin&operatorId=' + this.operatorID
    //         console.log('FR/LOGIN');
    //     }
    //     else if (window.location.pathname.indexOf('\/ar\/') > -1) {
    //         window.location.href = 'http://login.mondiamediamena.com/billinggw-lcm/billing?method=getcustomer&merchantId=243&redirect='+environment['link']+'ar%2Flogin&operatorId=' + this.operatorID
    //         console.log('AR/LOGIN');
    //     }
    //     else { 
    //         window.location.href = 'http://login.mondiamediamena.com/billinggw-lcm/billing?method=getcustomer&merchantId=243&redirect='+environment['link']+'en%2Flogin&operatorId=' + this.operatorID
    //         console.log('EN/LOGIN');
            
    //     }
    // }
    ngOnInit() {

        setTimeout(() => {
            /** spinner ends after 5 seconds */
            this.loaded = true;
        }, 1500);
    }
    loginCustomertoCustomer() { 
        this.http.get('https://api-staging.videyo.tv/manage/usernameToUsername?username=' + this.msisdn, {
        })
            .subscribe(
                data => {
                    console.log('Login Via Customer ID')
                    this.username = data['username'];
                    this.isTrue = data['isNew'];
                    this.tempPass = data['tempPassword'];
                    if (this.isTrue == false) {
                        this.hideUsername = true;
                    }
                    else {
                        this.newUserLoginMTN();
                    }

                },
                error => {

                }
            );
    }
    logincustomerID() {
        this.http.get('https://api-staging.videyo.tv/manage/customerIdToUsername?customerId=' + this.mondiacustID + '&operatorString=' + this.mondiaOperator, {
        })
            .subscribe(
                data => {
                    console.log('Login Via Customer ID')
                    this.username = data['username'];
                    this.isTrue = data['isNew'];
                    this.tempPass = data['tempPassword'];
                    if (this.isTrue == false) {
                        this.hideUsername = true;
                    }
                    else {
                        this.newUserLogin();
                    }

                },
                error => {

                }
            );

    }
    loginUserwithID(pass) {
        this.route.params.subscribe(params2 => {
            this.redirectURL = params2['redirect'];
            var currentUser
            var baseUrl = "https://api-staging.videyo.tv"

            this.http.post(baseUrl + '/api/login', {
                'username': this.username,
                'password': pass
            }).subscribe(
                res => {
                    localStorage.setItem('access_token', (res["access_token"]));
                    if (this.redirectURL) {

                        if (window.location.pathname.indexOf('\/en\/') > -1) {
                            window.location.href = '/en/"+decodeURIComponent(this.redirectURL)'

                        }
                        if (window.location.pathname.indexOf('\/fr\/') > -1) {
                            window.location.href = '/fr/"+decodeURIComponent(this.redirectURL)'

                        }
                        if (window.location.pathname.indexOf('\/ar\/') > -1) {
                            window.location.href = '/ar/"+decodeURIComponent(this.redirectURL)'

                        }
                    }
                    else {

                        if (window.location.pathname.indexOf('\/en\/') > -1) {
                            window.location.href = '/en/'

                        }
                        if (window.location.pathname.indexOf('\/fr\/') > -1) {
                            window.location.href = '/fr/'

                        }
                        if (window.location.pathname.indexOf('\/ar\/') > -1) {
                            window.location.href = '/ar/'

                        }
                    }


                },
                err => {
                    alert('Password Incorrect, Please try again or reset below');
                }
            );
            return false;
        });
        console.log('Login With User ID')
    }
    newUserLogin() {
        this.route.params.subscribe(params2 => {
            this.redirectURL = params2['redirect'];
            var currentUser
            var baseUrl = "https://api-staging.videyo.tv"

            this.http.post(baseUrl + '/api/login', {
                'username': this.username,
                'password': this.tempPass
            }).subscribe(
                res => {
                    localStorage.setItem('access_token', (res["access_token"]));
                    if (window.location.pathname.indexOf('\/fr\/') > -1) {
                        this.router.navigate(["/set-password"]);
                    }
                    else if  (window.location.pathname.indexOf('\/en\/') > -1) {
                        this.router.navigate(["/set-password"]);
                    }
                    else if (window.location.pathname.indexOf('\/ar\/') > -1) {
                        this.router.navigate(["/set-password"]);
                    }
                    else { 
                        this.router.navigate(["/set-password"]);
                    }


                },
                err => {
                    alert('Password Incorrect, Please try again or reset below');
                }
            );
            return false;
        });
        console.log('New User Login')
    }
    newUserLoginMTN() {
        this.route.params.subscribe(params2 => {
            this.redirectURL = params2['redirect'];
            var currentUser
            var baseUrl = "https://api-staging.videyo.tv"

            this.http.post(baseUrl + '/api/login', {
                'username': this.username,
                'password': this.tempPass
            }).subscribe(
                res => {
                    localStorage.setItem('access_token', (res["access_token"]));
                    if (window.location.pathname.indexOf('\/fr\/') > -1) {
                        this.router.navigate(["/"]);
                    }
                    else if  (window.location.pathname.indexOf('\/en\/') > -1) {
                        this.router.navigate(["/"]);
                    }
                    else if (window.location.pathname.indexOf('\/ar\/') > -1) {
                        this.router.navigate(["/"]);
                    }
                    else { 
                        this.router.navigate(["/"]);
                    }


                },
                err => {
                    alert('Password Incorrect, Please try again or reset below');
                }
            );
            return false;
        });
        console.log('New User Login')
    }
    loginUser(user, pass) {
        this.route.params.subscribe(params2 => {
            this.redirectURL = params2['redirect'];
            var currentUser
            var baseUrl = "https://api-staging.videyo.tv"

            this.http.post(baseUrl + '/api/login', {
                'username': this.usernameLogin = this.usernameLogin.replace(/\s/g, '').substring(1),
                'password': this.passLogin
            }).subscribe(
                res => {
                    localStorage.setItem('access_token', (res["access_token"]));
                    if (this.redirectURL) {
                        this.router.navigate(["/" + decodeURIComponent(this.redirectURL)]);
                    }
                    else {
                        this.router.navigate(["/"]);
                    }


                },
                err => {
                    alert('Password Incorrect, Please try again or reset below');
                }
            );
            return false;
        });
        console.log('Normal Login')
    }
    onUsernameUp(event: any) {
        this.usernameLogin = event.target.value;
        console.log(this.usernameLogin);
    }
    onPasswordUp(event: any) {
        this.passLogin = event.target.value;
        console.log(this.passLogin);
    }
}
